import { CartState } from './cart.reducer';
import { createFetchStateSelectors } from '@mkp/shared/util-state';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectCartState = createFeatureSelector<CartState>('cartState');

export const { selectLoaded: selectCartLoaded, selectLoading: selectCartLoading } =
  createFetchStateSelectors(selectCartState);

export const selectCart = createSelector(selectCartState, (state) => state.cart);

export const selectCartTokenValue = createSelector(
  selectCartState,
  (state) => state.cartTokenValue
);

export const selectFetchState = createSelector(selectCartState, (state) => state.fetchState);

export const selectNotes = createSelector(selectCartState, (state) => state.notes);

export const selectCartItems = createSelector(selectCart, (cart) => cart?.items);
